import Cookies from "js-cookie";

import { APIError } from "./error-utils";

interface RequestParams extends RequestInit {
  token?: string | null;
}

interface RequestOptions {
  isTextResponse?: boolean;
}

export const request = async <Response extends unknown | undefined>(
  url: string,
  init: RequestParams = { method: "GET" },
  options: RequestOptions = { isTextResponse: false }
) => {
  // TODO: The following line won't work with React Native
  const csrftoken = Cookies.get("csrftoken");

  const response = await fetch(url, {
    credentials: "same-origin",
    ...init,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: init.token ? `Token ${init.token}` : "",
      "X-CSRFToken": csrftoken || "",
      ...init.headers,
    },
  });

  const text = await response.text();
  let body: unknown = text;

  if (!text) {
    // TODO: Find a better way of figuring out the response should be undefined
    return undefined as Response;
  }

  if (!options.isTextResponse) {
    try {
      body = JSON.parse(text);
    } catch (e) {
      throw new Error("Unable to parse API response", {
        cause: e,
      });
    }
  }

  if (!response.ok) {
    throw new APIError(response.status, response.statusText, body);
  }

  return body as Response;
};
